/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

export const FETCH_PRICING_VIEW = 'FETCH_PRICING_VIEW';
export const FETCH_PRICING_VIEW_SUCCESS = 'FETCH_PRICING_VIEW_SUCCESS';
export const FETCH_PRICING_VIEW_ERROR = 'FETCH_PRICING_VIEW_ERROR';
export const SET_FETCH_PRICING_VIEW_STATUS = 'SET_FETCH_PRICING_VIEW_STATUS';

export function fetchPricingViewSuccess(data) {
    return {
        type: FETCH_PRICING_VIEW_SUCCESS,
        payload: data,
    };
}

export function fetchPricingViewError(error) {
    return {
        type: FETCH_PRICING_VIEW_ERROR,
        payload: error,
    };
}

export function setFetchPricingViewStatus(status) {
    return {
        type: SET_FETCH_PRICING_VIEW_STATUS,
        payload: status,
    };
}

export function fetchPricingView(facilityId) {
    return {
        type: FETCH_PRICING_VIEW,
        payload: facilityId,
    };
}
